import * as React from "react";

import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import ListItemIcon from "@mui/material/ListItemIcon";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import { GearSix as GearSixIcon } from "@phosphor-icons/react/dist/ssr/GearSix";
import { SignOut as SignOutIcon } from "@phosphor-icons/react/dist/ssr/SignOut";
import { User as UserIcon } from "@phosphor-icons/react/dist/ssr/User";
import { paths } from "../utils/constants";
import useAuth from "../pages/login/hooks";
import { logoutUser } from "../utils/api";
import { useProfile } from "../pages/profile/hooks";

const formatRoleLabel = (role) => {
    if (!role) return '';
    return role
        .toString()
        .replace(/_/g, ' ')
        .toLowerCase()
        .replace(/\b\w/g, (c) => c.toUpperCase());
};

export function UserPopover({ selectedPopover, anchorEl, onClose, open }) {
    const { detail } = useAuth();
    const { profile, setProfile } = useProfile();

    React.useEffect(() => {
        if (!Object.keys(profile).length) {
            let student = JSON.parse(localStorage.getItem('profile')) || {};
            if (student && Object.keys(student).length) {
                setProfile(student);
            }
        }
    }, []);

    return (
        <Popover
            anchorEl={anchorEl}
            anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
            onClose={onClose}
            open={open}
            slotProps={{ paper: { sx: { width: "240px" } } }}
        >
            <Box sx={{ p: "16px 20px " }}>
                <Typography variant="subtitle1"> {Object.keys(profile).length > 0 ? `${profile?.firstName} ${profile?.lastName}` : `${detail?.firstName} ${detail?.lastName}`}</Typography>
                <Typography color="text.secondary" variant="body2">
                    {profile?.gradeLevel || profile?.grade || formatRoleLabel(profile?.academicStaffProfile || detail?.roles?.[0]?.role) || '-'}
                </Typography>
                {/* <Typography color="text.secondary" variant="body2">
                    {Object.keys(detail).length > 0 ? `${detail.email}` : '-'}
                </Typography> */}
            </Box>
            <Divider />
            <MenuList
                disablePadding
                sx={{ p: "8px", "& .MuiMenuItem-root": { borderRadius: 1 } }}
            >
                {/* <MenuItem href={paths.dashboard.settings} onClick={onClose}>
                    <ListItemIcon>
                        <GearSixIcon fontSize="var(--icon-fontSize-md)" />
                    </ListItemIcon>
                    Settings
                </MenuItem> */}
                <MenuItem href={paths.dashboard.account} onClick={() => selectedPopover('profile')}>
                    <ListItemIcon>
                        <UserIcon fontSize="var(--icon-fontSize-md)" />
                    </ListItemIcon>
                    Profile
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        logoutUser()

                    }}
                >
                    <ListItemIcon>
                        <SignOutIcon fontSize="var(--icon-fontSize-md)" />
                    </ListItemIcon>
                    Sign out
                </MenuItem>
            </MenuList>
        </Popover>
    );
}
